import {
  CoreApi,
  PinResponse,
  AtlasCreateRequest,
  AtlasResponse,
  AtlasUpdateRequest,
  AtlasReadRequest,
  AtlasViewBoxRequest,
  AtlasCentroidResponse,
  AtlasShapeResponse,
  BlobContentType,
  ImportAtlasDataRequest,
  IdKeyType,
  AtlasMapResponse,
  AtlasRequest,
  Boundaries,
  AtlasPinRequest,
} from "@hokuto/jam-core";
import {
  SearchViewBoxApi,
  fetchAtlasImage,
  fetchAtlasSvg,
  fetchBlob,
  fetchJSON,
  fetchUpload,
} from "./fetch.js";
import { ApiMethod } from "../types.js";
import { getAtlasImageUrl } from "./url.js";

export const AtlasApi = {
  Search: new SearchViewBoxApi<AtlasRequest, AtlasResponse, AtlasMapResponse>(
    CoreApi.Atlas.Search
  ),
  Create: fetchJSON<AtlasCreateRequest, AtlasResponse>(
    CoreApi.Atlas.Create,
    ApiMethod.Post
  ),
  Read: fetchJSON<AtlasReadRequest, AtlasResponse>(CoreApi.Atlas.Read),
  Update: fetchJSON<AtlasUpdateRequest, AtlasResponse>(
    CoreApi.Atlas.Update,
    ApiMethod.Put
  ),
  Delete: fetchJSON<AtlasReadRequest>(CoreApi.Atlas.Delete, ApiMethod.Delete),
  Clone: fetchJSON<AtlasReadRequest, AtlasResponse>(
    CoreApi.Atlas.Clone,
    ApiMethod.Post
  ),
  Export: fetchBlob<AtlasReadRequest>(
    CoreApi.Atlas.Export,
    BlobContentType.Json
  ),
  Import: fetchUpload<ImportAtlasDataRequest, { [IdKeyType.Atlas]: string }>(
    CoreApi.Atlas.Import
  ),
  Centroid: fetchJSON<AtlasViewBoxRequest, AtlasCentroidResponse>(
    CoreApi.Atlas.Centroid
  ),
  Image: fetchAtlasImage(CoreApi.Atlas.Image),
  ImageUrl: getAtlasImageUrl(CoreApi.Atlas.Image),
  Label: fetchAtlasImage(CoreApi.Atlas.Label),
  LabelUrl: getAtlasImageUrl(CoreApi.Atlas.Label),
  Pin: fetchJSON<AtlasPinRequest, PinResponse>(CoreApi.Atlas.Pin),
  ViewBox: fetchJSON<AtlasViewBoxRequest, Boundaries>(CoreApi.Atlas.ViewBox),
  Shape: fetchJSON<AtlasViewBoxRequest, AtlasShapeResponse>(
    CoreApi.Atlas.Shape
  ),
  Svg: fetchAtlasSvg(CoreApi.Atlas.Svg),
};
